export enum timelineSocialType {
    instagram = "Instagram",
    twitter = "Twitter",
    discord = "Discord",
}
